import { INotificacionStatus, IContactoPrestador, ModalTypes, ModalActions } from "../../consts/ModalTypes";

export const openModalDatos = (payload : boolean) : ModalActions => ({
    type: ModalTypes.HANDLE_MODAL,
    payload
});

export const openModalNotificacion = (payload : INotificacionStatus) : ModalActions => ({
    type: ModalTypes.HANDLE_MODAL_NOTIFICACION,
    payload
})

export const guardarDatosContacto = (payload : IContactoPrestador) : ModalActions => ({
    type: ModalTypes.GUARDAR_DATOS_CONTACTO,
    payload
})